import styled from 'styled-components';
import { shouldForwardProp } from '../../utils';
import expandedLayoutProps from './expandedLayoutProps';
var Box = styled('div').withConfig({
  shouldForwardProp: shouldForwardProp,
  displayName: "Box",
  componentId: "sc-vludf4-0"
})(expandedLayoutProps);
/** @component */

export default Box;